module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sk":{"ShopCertificates":{"heading":"Certifikace CVB s.r.o."}},"cs":{},"de":{}}')
  delete Component.options._Ctor
}
